/* eslint-disable @typescript-eslint/no-explicit-any */
import { createApiRef } from '@backstage/core-plugin-api';
import { MarketplaceResponse } from '@principal-developer-portal/ui';

export const marketplaceApiRef = createApiRef<MarketplaceApi>({
  id: 'plugin.marketplace.service',
});

export interface MarketplaceApi {
  getPatterns: () => Promise<MarketplaceResponse[]>;
  getUtilities: () => Promise<MarketplaceResponse[]>;
  getApis: () => Promise<MarketplaceResponse[]>;
  getAll: () => Promise<MarketplaceResponse[]>;
}
